import { Dimensions, GestureResponderEvent, Image, StyleSheet, View } from 'react-native'
import { BaseModalConfig } from '..'
import PeopleOnCall from './assets/PeopleOnCall.png'
import { DS } from '../../../../../design-system'

export interface JoinCallProps extends BaseModalConfig {
  onJoinVideo: (event: GestureResponderEvent) => void
  onJoinAudio: (event: GestureResponderEvent) => void
  onJoinWithAvOff: (event: GestureResponderEvent) => void
}

export const JoinCall = ({ onJoinVideo, onJoinAudio, onJoinWithAvOff, onClose }: JoinCallProps) => {
  // TODO why dont just call useJoinCall here instead of props?
  const WIDTH = Dimensions.get('screen').width // we use this breakpoint to detect small devices
  const isSmallDevice = WIDTH < 370

  return (
    <View style={styles.bottomSheetContainer}>
      <Image
        source={PeopleOnCall}
        style={[styles.image, isSmallDevice ? styles.smallImageSize : styles.bigImageSize]}
      />
      <DS.Text variant="Body Large/Regular" style={{ fontSize: isSmallDevice ? 16 : 18 }} textAlign="center">
        {'Turn on your camera to connect with friends and elevate the poker game.'}
      </DS.Text>
      <DS.Frame style={{ paddingHorizontal: 16, gap: 8 }}>
        <DS.Button variant="Medium/Primary" type={'On Light'} onPress={onJoinVideo}>
          {'Yes, let’s go live'}
        </DS.Button>
        <DS.Button variant="Medium/Primary" type={'On Dark'} style={styles.button} onPress={onJoinAudio}>
          {'Turn on audio only'}
        </DS.Button>
        <DS.Button
          variant="Medium/Primary"
          type={'On Dark'}
          style={[styles.button, isSmallDevice ? { paddingHorizontal: 18 } : {}]}
          onPress={onJoinWithAvOff}
          numberOfLines={1}
        >
          {'No, keep camera and mic off'}
        </DS.Button>
      </DS.Frame>
    </View>
  )
}

const styles = StyleSheet.create({
  bottomSheetContainer: {
    width: '100%',
    paddingVertical: 32,
    paddingHorizontal: 16,
    gap: 16
  },
  button: {
    backgroundColor: DS.palette['Brand/Cream'],
    borderWidth: 1,
    borderColor: DS.palette['Brand/Light Grey']
  },
  image: {
    alignSelf: 'center'
  },
  bigImageSize: {
    height: 148,
    width: 148
  },
  smallImageSize: {
    height: 110,
    width: 110
  }
})
